import { t } from "i18next"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeaderModal from "../components/headerModal"

import ManagerTimeslot from "../components/managerTimeslot";

const EditAgenda = () => {

  const { namePharmacy } = useSelector((state: any) => state.login);
  const navigate = useNavigate();
  return (
    <>

      <HeaderModal textButtonRight={t('go-to-prenotations')} handleClick={() => { navigate('/prenotation') }} title={t('title-header-modale', { nameBrand: namePharmacy })} />
      <ManagerTimeslot />


    </>
  )
}

export default EditAgenda